import { defineStore } from "pinia"

export const useNotificationStore = defineStore("notification", {
  state: () => ({
    error: null,
  }),
  getters: {
    getError: state => state.error,
  },
  actions: {
    raiseError(error) {
      if (!error || !error.message) {
        error.message = "ERROR"
      }
      this.error = error
    },
    dismissError() {
      this.error = {
        status: null,
        message: "",
        // A stale id would label the next failure with the previous one's trace.
        traceId: null,
      }
    },
  },
})
